import { render, staticRenderFns } from "./QuestionColorRectIcon.vue?vue&type=template&id=75a72d15&"
import script from "./QuestionColorRectIcon.vue?vue&type=script&lang=js&"
export * from "./QuestionColorRectIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports